import styled from "styled-components";

export const Container = styled.div`
  /* padding: 54px 30px;*/
  background-color: var(--section-background);
  padding: 52px 28px 15px;
  width: 100%;
  box-shadow: 0px 3px 5px rgb(0 0 0 / 5%);
  max-height: calc(100vh - 56px);
  overflow: auto;
  .action-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 591px;
    width: 100%;
    justify-content: flex-start;
    button {
      min-width: 72px;
      justify-content: center;
      font-family: "latobold";
    }
    svg {
      cursor: pointer;
    }
  }
`;
export const TableContainer = styled.div`
  padding: 0 0 0 30px;
  width: 100%;
  max-height: 350px;
  overflow: auto;
  .table-head {
    th {
      :first-child {
        /* width: 50%; */
        text-align: left;
        padding-left: 77px;
      }
      :last-child {
        text-align: center;
        width: 100px;
      }
    }
  }
  .body {
    /* td:first-child {
      text-align: center;
    } */
    .text-wrapper {
      display: inline-grid;
      align-items: center;
      gap: 30px;
      grid-template-columns: 17px 1fr;
    }
  }
`;
export const Heading = styled.div`
  padding-right: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  width: 100%;
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 150.5%;
    color: var(--text-primary);
    line-height: 31px;
  }
  p {
    font-size: 14px;
    color: var(--text-primary);
  }
`;

export const BoxContainer = styled.div`
  margin-bottom: 24px;
`;

export const MainSection = styled.div`
  display: flex;
  align-items: flex-start;
  @media (max-width: 1350px) {
    flex-direction: column;
  }
`;

export const AddNewMsg = styled.div`
  padding: 22px 0;
  border-bottom: 1px solid #00000014;
  button {
    font-family: "latobold";
  }
`;

export const AlertsSection = styled.div``;

export const WorkSection = styled.div`
  background: var(--inner-section-bg);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
  padding: 30px 40px;

  /* > div {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 30px 7.708vw;
    margin-bottom: 10px;
  } */

  .input-wrapper {
    max-width: 591px;
    width: 100%;
    p {
      font-size: 13px;
      color: var(--text-primary);
      margin-bottom: 10px;
    }
    input {
      background: var(--input-background);
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 6px;
      display: block;
      width: 100%;
      margin-bottom: 10px;
      height: 40px;
      border-radius: 6px;
      font-size: 13px;
      padding: 9px 10px;
    }
    textarea {
      min-width: 100%;
      max-width: 591px;
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 6px;
      padding: 10px;
      margin-bottom: 20px;
    }
  }

  .select-wrapper {
    .select {
      margin-bottom: 10px;
      margin-top: 4px;
    }
    label {
      font-size: 13px;
      color: #1d1d1d;
    }
    .MuiFormControl-root {
      margin: 0;
      width: 100%;
    }
    .MuiSelect-select {
      background: var(--input-background);
      border: 1px solid var(--table-un-check-color);
      border-radius: 6px;
      font-size: 13px;
      padding: 2.5px 10px;
    }
  }
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  /* padding-bottom: 27px;
  border-bottom: 1px solid #0000001a; */

  &.no-side-border {
    ::after {
      display: none;
    }
  }

  .checkbox {
    border: 1px solid var(--table-un-check-color);
    border-radius: 6px;
    padding: 0 10px;
    display: inline-flex;
    align-items: center;
    min-width: 270px;
    min-height: 30px;
  }
  .MuiCheckbox-root {
    padding: 0;
    padding-right: 5px;
  }
  .MuiTypography-root {
    font-size: 13px;
    white-space: normal;
    padding-right: 30px;
  }
  label {
    font-size: 13px;
    color: #1d1d1da6;
    margin: 0;
  }
`;

export const CheckBoxInnerWrapper = styled.div`
  background: var(--input-background);
  border: 1px solid var(--table-un-check-color);
  border-radius: 6px;
  height: 30px;
  display: inline-flex;
  padding: 0 13px 0 10px;
`;

export const LeftSection = styled.div`
  max-width: 432px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 22px 0;
  border-right: 1px solid #0000001a;
  transition: max-width 0.3s;

  .input-wrapper {
    padding-right: 30px;
    p {
      font-size: 16px;
      text-transform: uppercase;
      font-family: "latobold";
      margin-bottom: 20px;
      margin-top: 28px;
    }
    textarea {
      background: var(--input-background);
      border: 1px solid var(--table-row-border-color);
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      min-width: calc(100% - 30px);
      padding: 20px;
      font-size: 13px;
      width: 100%;
      margin-bottom: 20px;
      max-width: 100%;
    }
  }

  @media (max-width: 1350px) {
    max-width: 591px;
    border-bottom: 1px solid #0000001a;
    border-right: none;
    .input-wrapper {
      padding-right: 0;
    }
  }
`;
